import { render, staticRenderFns } from "./TopAgentsLeaderboard.vue?vue&type=template&id=3ab70e33&scoped=true&"
import script from "./TopAgentsLeaderboard.vue?vue&type=script&lang=js&"
export * from "./TopAgentsLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./TopAgentsLeaderboard.vue?vue&type=style&index=0&id=3ab70e33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab70e33",
  null
  
)

export default component.exports